















































































































































































































import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'

import { NetworkService } from '@/services/NetworkService'
import { PaymentCalculatorService } from '@/services/PaymentCalculatorService'

import { Status } from '@/enums/status'

/* eslint-disable */ 
import { User } from '../models/User'
import { Product } from '../models/Product'
import { OrderItem } from '../models/OrderItem'
/* eslint-enable */ 

export default Vue.extend({
  data: () => ({
    loading: false as boolean,
    customers: [] as User[],
    search: null,
    customer: null as (any | User),
    confirmed: false,
    snackbar: false,
    snackbarText: 'Please ensure either a customer is selected or the form is filled out correctly.',
    window: window,
    emailDialog: false,
    email: '',
    order: {
      id: -1,
      subtotal: 0,
      tax: 0,
      total: 0,
      products: [] as Product[]
    },
    orderProducts: [] as Product[],
    dealerNotes: '' as string,
    customerNotes: '' as string,
    headers: [
      {
        text: 'Product Name',
        align: 'start',
        sortable: false,
        value: 'name'
      },
      {
        text: 'Product Number',
        sortable: false,
        value: 'number'
      },
      {
        text: 'Quantity',
        sortable: false,
        value: 'quantity'
      },
      {
        text: 'Total',
        sortable: false,
        value: 'total'
      }
    ],
    form: {
      first_name: '',
      last_name: '',
      phone_number: '',
      email: '',
      dealer_id: 0
    },
    confirmedPayment: null as number,
    step: 1
  }),
  props: ['emptyCart'],
  watch: {
    search (searchValue : string) {
      searchValue && searchValue !== this.customer && this.querySelections(searchValue)
    }
  },
  computed: {
    ...mapGetters({
      auth: 'auth/authenticated',
      isProductAdvisor: 'auth/isProductAdvisor',
      isDealerAdmin: 'auth/isDealerAdmin',
      currentDealer: 'dealers/currentDealer',
      frequency: 'terms/currentFrequency',
      cartProducts: 'cart/products',
      rate: 'terms/rate',
      term: 'terms/term',
      subtotal: 'cart/subtotal',
      authenticated: 'auth/authenticated',
      taxRate: 'cart/taxRate',
      currentUser: 'auth/currentUser',
      currentTrim: 'trims/currentTrim',
    }),
    obs () : any {
      return this.$refs.observer as any
    },
    priceObserver() : any {
      return this.$refs.priceObserver as any
    },
    paymentPeriods() : number {
      return PaymentCalculatorService.getPaymentPeriods(this.frequency)
    },
    payment() : number {
      return PaymentCalculatorService.calculatePayment(this.rate, this.subtotal, this.paymentPeriods, this.term)
    },
    taxTotal() : number {
      return (this.subtotal * (this.taxRate / 100))
    },
    total() : number {
      return this.subtotal + this.taxTotal
    },
    currentTitle () {
      switch(this.step) {
        case 1: return 'Select a customer'
        case 2: return 'Checkout'
        case 3: return 'Order Confirmation'
        default: return 'Order Confirmation'
      }
    }
  },
  mounted() {
    if (this.isProductAdvisor) {
      this.step = 1
      this.storeOriginalPrice()
    } else {
      this.step = 2
      this.customer = this.currentUser
    }
  },
  methods: {
    ...mapActions({
      createUser: 'auth/createUserWithoutPassword',
      createOrder: 'cart/createOrder',
      updateCartWithProduct: 'cart/updateCartWithProduct'
    }),
    async updateOrderItem(item: OrderItem) {
      const isValid = await this.priceObserver.validate()
      if (isValid) {
        this.$store.dispatch('cart/updateCartWithProduct', { orderItem: item, auth: this.auth, customerId: this.customer.id })
      }
    },
    storeOriginalPrice() {
      this.cartProducts.forEach((item: OrderItem) => {
        item.originalPrice = item.total
      })
    },
    continueShopping() : void {
      this.$router.push('/' + this.$route.params.makeId + '/' + this.$route.params.dealerCode + '/products')
    },
    async checkout() {
      this.loading = true
      // Different checkout requirements for administrators versus customers
      if (this.authenticated && this.isProductAdvisor) {
        this.setUpOrder(this.customer.id, this.currentUser.id)
      // If it is a customer and not an administrator checking out
      } else {
        this.setUpOrder(this.currentUser.id, -1)
      }
      this.loading = false
      this.step++
    },
    async querySelections(searchValue : string) {
      this.loading = true
      const users = await User.getUsersByDealer(this.currentDealer.id, searchValue)
      this.customers = []
      this.customers = users
      this.loading = false
    },
    async sendEmail() {
      this.loading = true
      const res = await NetworkService.get(
        process.env.VUE_APP_API_BASE_URL +
        '/api/v1/mail/checkout_summary?dealer=' + this.currentDealer.id + '&email=' + this.email + '&user=' + this.currentUser.id
      ) 
      if(res.data.success === true) {
        this.snackbarText = 'E-mail successfully sent to the address provided.'
      } else {
        this.snackbarText = 'There was an error sending the e-mail. Please wait before trying again.'
      }
      this.snackbar = true
      this.loading = false
      this.emailDialog = false
    },
    async setUpOrder(customerId: number, sellerId: number) {
      this.order.products = this.cartProducts
      this.order.subtotal = this.subtotal
      this.order.tax = this.taxTotal
      this.order.total = this.total
      this.confirmedPayment = this.payment
      const finalOrder = await this.createOrder({ statusId: Status.ORDER, customerId: customerId, sellerId: sellerId, dealerId: this.currentDealer.id, customerNotes: this.customerNotes, dealerNotes: this.dealerNotes })
      this.order.id = finalOrder.data.order.id
      this.confirmed = true
    },
    userSearch(item: User, queryText: string) {
      return item.firstName.toLowerCase().indexOf(queryText.toLowerCase()) > -1 || item.lastName.toLowerCase().indexOf(queryText.toLowerCase()) > -1 || item.email.toLowerCase().indexOf(queryText.toLowerCase()) > -1 || item.phoneNumber.toLowerCase().indexOf(queryText.toLowerCase()) > -1
    },
    async selectCustomer() {
      if (this.customer) {
        this.step++
      } else {
        this.loading = true
        const isValid = await this.obs.validate()
          if (isValid) {
            this.form.dealer_id = this.currentDealer.id
            const response = await this.createUser(this.form)
            this.customer = response
            this.storeOriginalPrice()
            this.step++
          } else {
            this.snackbarText = 'Please select a customer or register a new user as the customer.'
            this.snackbar = true
          }
          this.loading = false
      }
    }
  } 
})

